export default {"src":"/_next/static/media/speaker_notes_black_48dp.5f3b9c4c.svg","height":48,"width":48};